import config from './config'


export function goPC(to) {


    if (window.IsPC()) {
        //go to pc

        const name = to.name;
        const id = to.params.id;
      
        if (name == "Vote" || name == 'csco' || name == 'Bms' || name == 'DocVote' || name == 'DocPreview'  || name == 'CAXCaseVotePCHomePage' || name == 'CAXCaseVoteH5HomePage' || name == 'CAXCaseVoteLogin' || name == 'CAXCaseVotePCList' || name == 'CAXCaseVoteH5List' || name == 'CAXCaseVoteH5Detail' || name == 'CAXCaseVotePCDetail' || name == 'DocPreviewNew' || name == 'LivePreviewNew' || name == 'EasternCancerCasesHome' || name == 'gastricRes' || name == 'NewFeedBack') {
            return;
        }

        if (self != top) {
            // alert('在iframe里')
            return
        }

        // 跳pc——iframe
        // let pathArray = window.location.href.split('/#/')
        // if (pathArray && pathArray.length > 0 && name != 'pcProject' ) {
        //     let appUrl = ''
        //     if (pathArray[1]) {
        //         appUrl = encodeURIComponent(Base64.encode(pathArray[1]))
        //     }
        //     let newPath = pathArray[0] + '/#/pcProject?fullpath=' + appUrl
        //     setTimeout(() => {
        //         location.href = newPath    
        //     }, 100)
        //     return
        // }

        let fullUrl =  window.location.href || ''
        if ( name != 'pcProject' ) {
            let appUrl = encodeURIComponent(fullUrl)
            let newPath =  Global_root_path + '#/pcProject?fullpath=' + appUrl
            setTimeout(() => {
                location.href = newPath    
            }, 100)
            return
        }

        // let redirectUrl = "";

        // const baseUrl = "https://www.liangyihui.net/";

        // let secondUrl = ""
        // if (id) {
        //     secondUrl = "/" + id;
        // }

        // if (!config[name]) {
        //     redirectUrl = baseUrl;
        // } else {
        //     redirectUrl = baseUrl + config[name] + secondUrl;
        // }


        // let qd = to.query.qd
        // if (!qd) {
        //     qd = sessionStorage.getItem('for_count_qd')
        // } else {
        //     sessionStorage.setItem('for_count_qd', qd)
        // }

        // if (qd) {
        //     redirectUrl = redirectUrl + '?qd=' + qd
        // }

        // if (process.env.NODE_ENV == 'production') {
        //     location.href = redirectUrl
        // }
    } else {
        // go to 手机
        const name = to.name
        if (window.ISMOBILE && !window.ISAPP && !window.ISWXMINI && name == 'pcProject') {
            let appendArray = window.location.href.split('pcProject?fullpath=')
            if (appendArray.length > 1) {
                let appPath = ''
                if (appendArray[1]) {
                    appPath = decodeURIComponent(appendArray[1])
                }
                location.href = appPath
                setTimeout(() => {
                    location.href = appPath
                }, 100)
                return
            }
        }
        // if (window.ISMOBILE && name == 'pcProject') {
        //     let appendArray = window.location.href.split('pcProject?fullpath=')
        //     if (appendArray.length > 1) {
        //         let appPath = ''
        //         if (appendArray[1]) {
        //             let deUri = decodeURIComponent(appendArray[1])
        //             appPath = Base64.decode(deUri)
        //         }
        //         location.href = appendArray[0] + appPath
        //         setTimeout(() => {
        //             location.href = appendArray[0] + appPath  
        //         }, 100)
        //         return
        //     }
        // }
    }
}





// export {goPC, Kittydar};
// export {myObject as default};
// import * as cows from "cows";